// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".topic__item{max-height:100%}.item-wrap{display:grid;width:100%}", "",{"version":3,"sources":["webpack://./src/components/topic/Topic.scss"],"names":[],"mappings":"AAAA,aACI,eAAA,CAGJ,WACI,YAAA,CACA,UAAA","sourcesContent":[".topic__item {\n    max-height: 100%;\n}\n\n.item-wrap{\n    display: grid;\n    width: 100%\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
